// As integrações de cada escritório (Asaas, Tramitação Inteligente) —
// Configurações → Integrações (09/10/2026). O ESTADO vem do servidor
// (Integracoes::DoEscritorio); aqui só a tradução dele em tom e o mapa do que
// cada integração liga no advup ("isso aqui vai interligar com o quê?",
// Victor). O mapa com o caminho no código: docs/integracoes/ASAAS-E-TRAMITACAO.md.

export const FORNECEDORES = ['asaas', 'tramitacao'];

// Cor só onde carrega significado: teal funcionando, âmbar falta um passo,
// rubi parou, neutro desligada ou ainda sem chave.
const TOM_DO_ESTADO = {
  conectada: 'teal',
  falta_testar: 'ambar',
  sem_avisos: 'ambar',
  sem_dono: 'ambar',
  chave_recusada: 'rubi',
  avisos_parados: 'rubi',
  desligada: 'neutro',
  sem_chave: 'neutro',
};

export const tomDoEstado = estado => TOM_DO_ESTADO[estado] || 'neutro';

// O passo seguinte que a tela oferece como botão principal.
export const proximoPasso = retrato => {
  if (!retrato) return null;
  const { estado } = retrato;
  if (['sem_avisos', 'avisos_parados'].includes(estado)) return 'conectar';
  if (['falta_testar', 'chave_recusada'].includes(estado)) return 'testar';
  return null;
};

// O que cada integração liga. `ativa` diz se, com o retrato de agora, aquela
// ligação está funcionando — a tela apaga a que ainda não está.
export const ligacoes = (fornecedor, retrato = {}) => {
  const temChave = !!retrato.chave_salva;
  if (fornecedor === 'asaas') {
    // Chave recusada: nada do Asaas funciona, mesmo "ligada".
    const ligada =
      temChave && !!retrato.ligada && retrato.estado !== 'chave_recusada';
    return [
      {
        chave: 'COBRANCA',
        icone: 'i-ph-receipt',
        rota: 'financial_index',
        ativa: ligada,
      },
      {
        chave: 'BAIXA',
        icone: 'i-ph-check-circle',
        rota: 'financial_index',
        ativa: ligada && !!retrato.avisos?.conectados,
      },
      {
        chave: 'ENCARGOS',
        icone: 'i-ph-percent',
        rota: 'financial_index',
        ativa: ligada,
      },
      {
        chave: 'REGUA',
        icone: 'i-ph-chat-circle-dots',
        rota: 'financial_index',
        consulta: { aba: 'cobranca' },
        ativa: ligada,
      },
    ];
  }
  // A chave recusada no teste (a Tramitação não guarda saúde no servidor:
  // a tela assume o estado logo depois do teste que falhou).
  const funciona = temChave && retrato.estado !== 'chave_recusada';
  return [
    {
      chave: 'ASSINATURA',
      icone: 'i-ph-signature',
      rota: 'minutas_assinaturas',
      ativa: funciona,
    },
    {
      chave: 'CONTRATOS',
      icone: 'i-ph-handshake',
      rota: 'legal_contracts_index',
      ativa: funciona,
    },
    {
      chave: 'CARTEIRA',
      icone: 'i-ph-folders',
      rota: 'legal_processes_index',
      ativa: funciona,
    },
    {
      chave: 'PUBLICACOES',
      icone: 'i-ph-newspaper',
      rota: 'legal_publications_index',
      ativa: funciona,
    },
    {
      chave: 'ANDAMENTOS',
      icone: 'i-ph-git-commit',
      rota: 'legal_processes_index',
      ativa: funciona && !!retrato.fonte_de_andamentos,
    },
  ];
};

// Percentual digitado como se escreve no Brasil ("2,5"). Vazio é null:
// "herdar do Asaas", que é diferente de zero ("sem encargo").
export const percentual = valor => {
  const texto = String(valor ?? '')
    .trim()
    .replace(',', '.');
  if (!texto) return null;
  const numero = Number(texto);
  return Number.isFinite(numero) ? numero : null;
};

// Chave em branco quer dizer "não mexi" (o servidor mantém a salva).
export const montarEnvio = (fornecedor, form) => {
  const envio = { ...form };
  const campoDaChave =
    fornecedor === 'asaas' ? 'asaas_api_key' : 'tramitacao_api_key';
  if (!String(envio[campoDaChave] || '').trim()) delete envio[campoDaChave];
  if (fornecedor === 'asaas') {
    ['default_interest_percent', 'default_fine_percent'].forEach(campo => {
      envio[campo] = percentual(envio[campo]);
    });
  }
  return envio;
};
